<template>
  <!-- <a-form-item label="公告内容"> -->
    <quill-editor
      :content="editorContent"
      :options="newOption"
      @change="editorChange"
      ref="newEditor"
      style="height: 200px; margin-bottom: 54px"
    >
    </quill-editor>
  <!-- </a-form-item> -->
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'CourseRichText',
  props: ['text', 'editorId'],
  components: { quillEditor },
  data () {
    return {
      editorContent: '',
      uniqueId: '',
      imgPercent: 0,
      form: this.$form.createForm(this, { name: "coordinated" }),
      imageLoading: false,
      newOption: {
        placeholder: '',
        history: {
          delay: 100,
          maxStack: 100,
          userOnly: false
        },
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            // ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            // [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            // [{ 'font': ['14'] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean'],
            // ['link', 'image', 'video']
          ]
        }
      }
    }
  },
  methods: {
    editorChange ({ editor, html, text }) {
        console.log("html",html)
        this.$emit('editorChange', html)
    }
  },
  watch: {
      //监控富文本内的变化
    text: function (val) {
      this.editorContent = val
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>

